export default __webpack_public_path__ + "static/media/Outfit-Light.ad7b6650.ttf";